<div class="month-shell">
    <div class="month-grid">
        <!-- Weekday row -->
        <div class="dow">
            <div class="dow-cell" *ngFor="let d of weekDays">{{ d }}</div>
        </div>

        <!-- 6x7 day cells -->
        <div class="days">
            <div class="day" *ngFor="let cell of cells; trackBy: trackByCell" [class.outside]="!cell.inMonth" (click)="onDayClick(cell, $event)"
                [class.today]="cell.isToday" (click)="openEventDialog(cell.date)">
                <div class="day-top">
                    <span class="day-number">{{ cell.date | date:'d' }}</span>
                </div>

                <div class="events" *ngIf="getEventsForCell(cell).length > 0">
                    <div class="event" *ngFor="let e of getVisibleEvents(cell)"
                        [style.border-left-color]="e.backColor || '#1a73e8'" (click)="onEventClick(e, $event)"
                        [ngbTooltip]="bubbleTpl"
                        triggers="mouseenter:mouseleave" container="body" placement="auto"
                        (mouseenter)="hoverBubbleHtml = e.bubbleHtml || ''"
                        (mouseleave)="hoverBubbleHtml = ''"
                        tooltipClass="dw-bubble-tooltip">
                        <span class="event-time">{{ e.start | date:'h:mm a' }}</span>
                        <span class="event-title">

                            {{ e.text || (e.start | date:'shortTime') + ' - ' + (e.end | date:'shortTime') }}
                        </span>
                        <i *ngIf="e.linkedCalendarEvent" class="fas fa-calendar-check linked-calendar-icon"
                            title="Linked to your calendar" aria-hidden="true"></i>
                        <i *ngIf="e.calendarSyncPending" class="fas fa-clock calendar-sync-pending-icon"
                            title="Calendar sync pending" aria-hidden="true"></i>
                    </div>
                    <!-- [ngbTooltip]="bubbleTpl" [tooltipContext]="{ html: e.bubbleHtml }" -->

                    <button *ngIf="getHiddenCount(cell) > 0" class="more" type="button"
                        (click)="onMoreClick(cell, $event)">
                        +{{ getHiddenCount(cell) }} more
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #bubbleTpl let-html="html">
    <div class="dw-bubble" [innerHTML]="sanitizeBubble(hoverBubbleHtml)"></div>
</ng-template>
